var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemaleBanned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5926_12221)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#9F9EA1",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.999 122H23.999C23.449 122 22.923 121.774 22.545 121.374C22.167 120.976 21.971 120.438 22.001 119.89C22.671 107.97 31.793 104.22 39.123 101.204C43.511 99.4 48.839 96.85 49.985 94.086C49.991 94.056 49.995 94.03 49.999 94C42.569 93.156 33.999 92.572 33.999 88C33.999 87.438 34.237 86.9 34.651 86.522C36.213 85.098 37.001 79.196 37.183 73.488C37.633 59.356 38.315 38 60.199 38C64.567 38 67.529 39.976 68.785 41.016C72.587 41.17 75.713 42.458 78.081 44.848C84.049 50.87 83.951 62.352 83.861 72.482C83.811 78.292 83.751 84.878 85.343 86.318C85.761 86.698 85.999 87.236 85.999 87.8C85.999 92.556 74.555 93.406 69.999 94C70.003 94.066 70.007 94.132 70.009 94.202C71.213 96.896 76.549 99.426 80.875 101.204C88.205 104.22 97.329 107.97 97.997 119.89C98.029 120.438 97.833 120.976 97.455 121.374C97.0751 121.774 96.549 122 95.999 122Z",
    fill: "#9F9EA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5926_12221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleBanned);
export default __webpack_public_path__ + "static/media/female-banned.bfbd2d479bf7469e73bb137d2a9a64a3.svg";
export { ForwardRef as ReactComponent };